import * as Actions from '../../actions/app'

const initialState = {
  stores: null,

  loading_crud_store: false,
  crud_store: false,

  loading_stock_in_stores_by_product: false,
  stock_in_stores_by_product: null,
}

const storesReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_STORES: {
      return {
        ...state,
        stores: action.payload,
      }
    }

    case Actions.CRUD_STORE: {
      return {
        ...state,
        loading_crud_store: action.payload.loading,
        crud_store: action.payload.crud,
      }
    }

    case Actions.GET_STOCK_IN_STORES_BY_PRODUCT_ID: {
      return {
        ...state,
        loading_stock_in_stores_by_product: action.payload.loading,
        stock_in_stores_by_product: action.payload.data ?? state.stock_in_stores_by_product,
      }
    }

    case Actions.SAVE_STORE_LOCATION: {
      const location = action.payload.data;
      if (!location || !state.stores) return state

      return {
        ...state,
        stores: state.stores.map(store => {
          if (store.almacen_id === Number(location.almacen_id)) {
            const currentLocations = store.ubicaciones || []
            // Check if exists
            const exists = currentLocations.find(l => l.ubicacion_almacen_id === location.ubicacion_almacen_id)
            let newLocations = []
            if (exists) {
              newLocations = currentLocations.map(l => l.ubicacion_almacen_id === location.ubicacion_almacen_id ? location : l)
            } else {
              newLocations = [...currentLocations, location]
            }
            return { ...store, ubicaciones: newLocations }
          }
          return store
        })
      }
    }

    case Actions.DELETE_STORE_LOCATION: {
      const { id, almacen_id } = action.payload
      if (!state.stores || !action.payload.deleted) return state

      return {
        ...state,
        stores: state.stores.map(store => {
          if (store.almacen_id === Number(almacen_id)) {
            return {
              ...store,
              ubicaciones: (store.ubicaciones || []).filter(l => l.ubicacion_almacen_id !== id)
            }
          }
          return store
        })
      }
    }

    default: {
      return state
    }
  }
}

export default storesReducer
